/* global G */
import { curry, getFirstItem } from 'lib/util'
import { get } from 'lib/sequence/component/state/value'
import states from 'model/address/collection/states'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'

/**
 * Returns the translated list of states for a specific country.
 *
 * @param {Gaia.AppModule.Spec} module            the current module object composition
 * @param {Gaia.Component.Spec} component         the object composition of the component that
 *                                                triggered the event handler
 * @param {Gaia.PlatformEvent|string} eventOrKey  the event or the key of the country to obtain
 * @returns {Object[]} countries
 */
// eslint-disable-next-line no-unused-vars
const listStates = (parent, source, module, component, eventOrKey) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const { [parent]: parentComponent } = sequenceComponentFindProxy(actionComponent)
  const targetParent = parent ? parentComponent : actionComponent

  const { [source]: country } = sequenceComponentFindProxy(targetParent)

  const countryValue = getFirstItem(get(country))
  const parentCountry = countryValue?.key || countryValue

  const key = eventOrKey?.detail?.key || eventOrKey
  const scope = parentCountry ? states.filter(item => item.parent === parentCountry) : []

  const list = scope
    .map(item => ({
      ...item,
      key: item.key,
      value: module[G.ADAPTER][G.INTL]._t(
        `states.${item.key}`,
        { ns: 'generic', _key: `states.${item.key}`, defaultValue: item.value },
      ),
    }))

  return list.sort((a, b) => a.value.localeCompare(b.value))
}

export const listStatesFromParent = curry((parent, source, module, component, event) => listStates(parent, source, module, component, event))

export default curry((module, component, event) => listStates(null, 'country', module, component, event))
